import React from "react";

const UserInfoColumn = React.memo((props) => (
  <div className="group-Column">
    {props.nombre && (<span className="text bold-text" title={props.nombre}>{`${props.nombre}`.toLowerCase()}</span>)}
    {props.email && (<span className="text-email bold-text" title={props.email}>{`${props.email}`.toLowerCase()}</span>)}

    <span className="text" title={props.rut}>{props.rut}</span>
  </div>
));

export default UserInfoColumn;
